import type { DeepPartial } from '@luna/utils-ts';

import type { Overview } from '../../types/Overview';

export const overviewROFeatureConfig: DeepPartial<Overview> = {
    applyPositionsForTitleCount: true,
    getSumPerTypeTotalMarketValue: true,
    sortAttribute: '-marketValue',
    stockValueTooltip: true,
    sumValueFromPositions: true,
    totalMarketValueFromPositions: true,
};
